<template>
  <div
    class="twy-absolute twy-inset-0 twy-bg-opacity-70 twy-z-20 yed-feedback twy-rounded-2xl twy-p-4 twy-flex twy-justify-center twy-items-center"
  >
    <div
      class="twy-z-21 twy-w-full twy-bg-white twy-text-black tw-y-1/2 twy-rounded-xl twy-p-4"
    >
      <p v-html="messageText"></p>

      <textarea
        class="twy-w-full twy-mt-2 twy-p-1 twy-border twy-rounded-xl"
        name="userFeedback"
        id="userFeedback"
        v-model.lazy="message"
      ></textarea>
      <p
        class="twy-text-red-500 twy-text-sm twy-mt-2 twy-text-center"
        v-if="error"
      >
        <span v-html="error"></span>
      </p>
      <div class="twy-mt-4 chat twy-flex twy-flex-wrap twy-justify-between">
        <CButton
          variant="cancel"
          @click="$emit('cancel')"
          class="twy-w-1/3 twy-justify-center twy-rounded-xl"
          v-html="cancelText"
        >
        </CButton>
        <CButton
          variant="accept"
          @click="onClick()"
          class="twy-w-1/3 twy-justify-center twy-rounded-xl"
          v-html="acceptText"
        >
        </CButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CButton from "../../common/c-button/index.vue";
export default {
  components: { CButton },
  data() {
    return {
      message: "",
      error: "",
      acceptText: "",
      cancelText: "",
      messageText: ""
    };
  },
  computed: {
    ...mapGetters("i18n", ["transLang"])
  },
  methods: {
    setMessage(message, buttons) {
      this.acceptText = buttons?.accept?.text || "Send";
      this.cancelText = buttons?.cancel?.text || "Cancel";
      this.messageText = message;
    },
    onClick() {
      this.$emit("accept", this.message);
    }
  }
};
</script>

<style lang="scss" scoped>
.yed-feedback {
  --yed-feedack-bg: rgba(1, 128, 147, 0.3);
  --yed-legal-text: var(--yed-messages-text);
  background: var(--yed-feedack-bg);
  color: var(--yed-legal-text, black);
}
</style>
